/* eslint-disable */

import type { PayslipCalculationsLang } from "./types/PayslipCalculationsLang";

let data: PayslipCalculationsLang | undefined;

export type { PayslipCalculationsLang };

export default function PayslipCalculationsLangFactory(): PayslipCalculationsLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setPayslipCalculationsLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/PayslipCalculationsLangDef").then(({ PayslipCalculationsLangDef }) => {
      data = PayslipCalculationsLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/PayslipCalculationsLangDef").then(({ PayslipCalculationsLangDef }) => {
      data = PayslipCalculationsLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/PayslipCalculationsLangDef").then(({ PayslipCalculationsLangDef }) => {
      data = PayslipCalculationsLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/PayslipCalculationsLangDef").then(({ PayslipCalculationsLangDef }) => {
      data = PayslipCalculationsLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

